import gql from 'graphql-tag'

export default (fieldId, { tableName, fieldName, variable, name }) => {
	return {
		mutation: gql`
			mutation (
				$field_id: bigint!
				$db_field_name: String!
				$db_table_name: String!
				$field_name: String!
				$field_variable: String!
			) {
				update_pdf_fields_by_pk(
					pk_columns: { id: $field_id }
					_set: {
						db_field_name: $db_field_name
						db_table_name: $db_table_name
						field_name: $field_name
						field_variable: $field_variable
					}
				) {
					id
				}
			}
		`,
		variables: {
			field_id: parseInt(fieldId),
			db_field_name: fieldName,
			db_table_name: tableName,
			field_name: name,
			field_variable: variable
		}
	}
}
